import { TypeaheadService } from "../../../../typeahead/typeahead.service";

var colorSearchJS = (function() {

    function getResult(className, id) {
        if (id != undefined) {
            id = id;
        } else {
            id = window.useDefaultcolorPaletteIdInPageBuilder || 2;
            if ($('.facade-of-the-year-form-usejs-pl').length > 0) {
                if (window.useStaticPalettes && window.useStaticPalettes.foty) {
                    id = window.useStaticPalettes.foty
                }
            }
        }

        $.ajax({
            url: "/ajaxGetColorsByPalette?palette_id=" + id
        }).done(function(colorPalette) {
            setCorolSearch(colorPalette);
        });
    }

    function destroySlick() {
        $("#colorNameFormBuilder").typeahead("destroy");
    }

    function getColorSearch(className, id) {
        getResult(className, id);
    }

    function setCorolSearch(colorPalette) {

        TypeaheadService.initCustomFilterTypeAheadLocal(
            "colors",
            colorPalette,
            "name",
            "input.color-search-form-builder",
            function(query, values) {
                return query.length > 0 ?
                    values.filter(
                        function(v) {
                            return v.name.indexOf(query) > -1;
                        }
                    ) : values
            },
            false,
            true,
            "No results found",
            function(data) {
                return '<div class="color-select-option" data-color-name="' + data.name + '" data-color-id="' + data.id + '"s><div class="name"><p>' + data.name + '</p></div><div class="color" style="background-color: #' + data.hex + '"></div></div>';
            }
        );

        /*setupTypeaheadLocal('input.color-search-form-builder',
                colorPalette,
                'name',
                false,
                null,
                null,
                data => {
                    return '<div class="color-select-option"><div class="name"><p>'+data.name+'</p></div><div class="color" style="background-color: #'+data.hex+'"></div></div>';
                }, "No results found", true
            );*/
    }

    $(document).on(
        "click",
        ".color-search-form-builder:not(.tt-input)",
        function() {
            getColorSearch();
        }
    );

    return {
        getColorSearch: getColorSearch
    };
})();

$(document).ready(function() {
    if ($(".color-search-form-builder").length > 0) {
        if (window.forceColorSearchPaletteId) {
            colorSearchJS.getColorSearch('color-search-form-builder', window.forceColorSearchPaletteId);
        } else {
            colorSearchJS.getColorSearch();
        }

    }
});

window.colorSearchJS = colorSearchJS;

export default colorSearchJS;